import { render, staticRenderFns } from "./ReschedulingRestructuring.vue?vue&type=template&id=73e5006d"
import script from "./ReschedulingRestructuring.vue?vue&type=script&lang=js"
export * from "./ReschedulingRestructuring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73e5006d')) {
      api.createRecord('73e5006d', component.options)
    } else {
      api.reload('73e5006d', component.options)
    }
    module.hot.accept("./ReschedulingRestructuring.vue?vue&type=template&id=73e5006d", function () {
      api.rerender('73e5006d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/ReschedulingRestructuring.vue"
export default component.exports